import { render, staticRenderFns } from "./404WithHeader.vue?vue&type=template&id=37a83d20&scoped=true"
import script from "./404WithHeader.vue?vue&type=script&lang=js"
export * from "./404WithHeader.vue?vue&type=script&lang=js"
import style0 from "./404WithHeader.vue?vue&type=style&index=0&id=37a83d20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a83d20",
  null
  
)

export default component.exports